import React, { useEffect, useState} from "react";
import {FormValidator, useFormValidator, Inputs} from "coaz-ui";

import client from '../client';

const AddUserGroup = ({params, submitRef, setLoading, setEnableSubmit}) => {
	const [userGroup, setUserGroup] = useState({});
	const minWidth = 320;
	const { request,errorMessage } = client;

	const submit = async (e) => {
		try {
            const response = await request("POST", "usergroups", userGroup);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
	};

	const [register, handleChange, handleSubmit, errors] =
		useFormValidator(submit);

	const inputs = [
		{
			label: "name",
			Group: "text",
			name: "name",
			value: userGroup && userGroup.name ? userGroup.name : "",
			placeholder: "Enter name...",
			onChange: (e) => {
				handleChange(e, onChange);
			},
			register: register,
			checks: ["empty"],
			errors: errors,
		},
	];

	const onChange = (e) => {
		const value = e.target.value;
		if (value === "") {
			setUserGroup({ ...userGroup, [e.target.name]: null });
		} else {
			setUserGroup({ ...userGroup, [e.target.name]: value });
		}
	};

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	useEffect(() => {
		setLoading(false);
	},[])
	
	return (
			<FormValidator>
				<div className="flex flex-col w-full h-auto">
					<div className="flex flex-col w-full h-auto space-y-4 shrink-0">
						<Inputs
							inputs={inputs}
							minWidth={minWidth}
							onSubmit={handleSubmit}
						/>
					</div>
				</div>
			</FormValidator>
	);
};

export default AddUserGroup;
